import styled from '@emotion/styled'
import React, { useMemo } from 'react'
import checkMark from '../../assets/icons/check-mark.svg'
import { StatusTimeLine } from '../models/Models'

export const TimeLine = ({ status }: { status: StatusTimeLine }) => {
  const { Layout } = TimeLine

  return (
    <Layout>
      <Step step={1} name="Dados do Aluno" status={status} />
      <Step step={2} name="Tipo de curso e CFC" status={status} />
      <Step step={3} name="Turmas disponíveis e geração de cobrança" status={status} />
      <Step step={4} name="Agendamento" status={status} />
      <Step step={5} name="Fim" status={status} />
    </Layout>
  )
}

TimeLine.Layout = styled.div`
  display: flex;
  margin: 10px 0px 40px 0px;
  justify-content: center;
  gap: 30px;
`

const Step = ({ step, name, status }: { step: number; name: string; status: StatusTimeLine }) => {
  const { Layout } = Step

  const defineStep = useMemo(() => {
    if (!status) return 0
    if (status === 'HIDDEN') return 0
    if (status === 'DADOS_ALUNOS') return 1
    if (status === 'TIPO_CURSO') return 2
    if (status === 'TURMAS') return 3
    if (status === 'AGENDAMENTO') return 4
    if (status === 'FIM') return 5
  }, [status])

  return (
    <Layout step={step} defineStep={defineStep}>
      <ContainerPointChecked step={step} name={name} defineStep={defineStep} />
    </Layout>
  )
}

Step.Layout = styled.div<{ step: number; defineStep: any }>(
  ({ step, defineStep }) => `
  width: 100%;
  max-width: 200px;
  position: relative;
  &:not(:last-child) {
    border-top: 2px solid ${defineStepContent(step, defineStep, 'Step')};
  }
  &:first-of-type{
    margin-left: 200px;
  }
  @media (max-width: 768px) {
    &:first-of-type{
    margin-left: 100px;
  }
  }
`
)
const ContainerPointChecked = ({
  step,
  name,
  defineStep,
}: {
  step: number
  name: string
  defineStep: any
}) => {
  const { Layout, Check, ContentCheck, TextStep, IconCheck } = ContainerPointChecked

  return (
    <Layout>
      <Check>
        <ContentCheck step={step} defineStep={defineStep}>
          <IconCheck src={checkMark} step={step} defineStep={defineStep} />
        </ContentCheck>
      </Check>
      <TextStep>{name}</TextStep>
    </Layout>
  )
}

ContainerPointChecked.Layout = styled.div`
  display: grid;
  place-items: center;
  width: 100px;
  position: absolute;
  left: -65px;
  top: -15px;
  /* z-index: 2; */
`

ContainerPointChecked.Check = styled.div`
  width: 30px;
  height: 30px;
  border: 2px solid #d4d4d4;
  background-color: #ffffff;
  display: grid;
  place-items: center;
  border-radius: 50%;
`
ContainerPointChecked.ContentCheck = styled.div<{ step: number; defineStep: any }>(
  ({ step, defineStep }) => `
  width: 20px;
  height: 20px;
  background-color: ${defineStepContent(step, defineStep, 'contentCheck')};
  border-radius: 50%;
  display: grid;
  place-items: center;
`
)

ContainerPointChecked.IconCheck = styled.img<{ step: number; defineStep: any }>(
  ({ step, defineStep }) => `
  width: 12px;
  filter: invert(100%);
  display: ${defineStepContent(step, defineStep, 'iconCheck')};
`
)

ContainerPointChecked.TextStep = styled.div`
  font-size: 11px;
`

function defineStepContent(step: number, defineStep: any, element: string) {
  if (element === 'contentCheck') {
    if (!defineStep) return '#FFFFFF;'
    if (step === defineStep || defineStep > step || defineStep + 1 === step) return '#fbba3e;'
  }
  if (element === 'iconCheck') {
    if (!defineStep || defineStep + 1 === step) return 'none;'
    if (step === defineStep || defineStep > step) return 'block;'
  }
  if (element === 'Step') {
    if (!defineStep) return '#D4D4D4;'
    if (step === defineStep || defineStep > step) return '#fbba3e;'
    return '#D4D4D4;'
  }
}
